import React from 'react';
import {useTranslation} from 'react-i18next';

import {ThemeProvider, ToggleSwitch} from '@pexip/components';

import {SettingsActionsRow} from '../components/SettingsActionsRow';
import {SettingsPanel, QualityList} from '@pexip/media-components';

import {getStreamQuality, setStreamQuality} from '../services/Media.service';
import {useConfig} from '../config';
import {TestId} from '../../test/testIds';
import {VIDEO_CONTENT_HINTS} from '@pexip/media';
import {applicationConfig} from '../applicationConfig';

export const Quality: React.FC = () => {
    const {t} = useTranslation();
    const [bandwidth] = useConfig('bandwidth');
    const [denoise, setDenoise] = useConfig('denoise');
    const [presoContentHint, setPresoContentHint] =
        useConfig('presoContentHint');

    return (
        <SettingsPanel>
            <ThemeProvider colorScheme="light">
                <QualityList
                    streamQuality={getStreamQuality(bandwidth)}
                    setStreamQuality={setStreamQuality}
                />
                {applicationConfig.audioProcessing && (
                    <SettingsActionsRow
                        title={t(
                            'settings.noise-suppression',
                            'Noise suppression',
                        )}
                        subtitle={t(
                            'settings.noise-suppression-desc',
                            'Recommended for open spaces. Removes background noise so others can hear you better.',
                        )}
                        data-testid={TestId.ToggleNoiseSuppressionRow}
                    >
                        <div style={{paddingInlineStart: '50px'}}>
                            <ToggleSwitch
                                onChange={isChecked =>
                                    setDenoise(isChecked, true)
                                }
                                labelModifier="hidden"
                                label={t(
                                    'settings.noise-suppression',
                                    'Noise suppression',
                                )}
                                name="name-labels-overlay"
                                data-testid={TestId.ToggleNoiseSuppression}
                                checked={denoise}
                            />
                        </div>
                    </SettingsActionsRow>
                )}
                <SettingsActionsRow
                    title={t(
                        'settings.prioritize-sharing-motion',
                        'Prioritize sharing motion',
                    )}
                    subtitle={t(
                        'settings.prioritize-sharing-motion-desc',
                        'Recommended when sharing content with video or with many animations.',
                    )}
                    data-testid={TestId.TogglePrioritizeSharingMotionRow}
                >
                    <div style={{paddingInlineStart: '50px'}}>
                        <ToggleSwitch
                            onChange={isChecked =>
                                setPresoContentHint(
                                    isChecked
                                        ? VIDEO_CONTENT_HINTS.Motion
                                        : VIDEO_CONTENT_HINTS.Detail,
                                    true,
                                )
                            }
                            labelModifier="hidden"
                            label={t(
                                'settings.prioritize-sharing-motion',
                                'Prioritize sharing motion',
                            )}
                            name="name-labels-overlay"
                            data-testid={TestId.TogglePrioritizeSharingMotion}
                            checked={
                                presoContentHint === VIDEO_CONTENT_HINTS.Motion
                            }
                        />
                    </div>
                </SettingsActionsRow>
            </ThemeProvider>
        </SettingsPanel>
    );
};
